import React from "react";

import shortenUrl from "./shortenUrl";

/**
 * @param {string} text
 * @param {RegExp} regex
 * @param {{className?: string, ignoreLast?: boolean}} options
 * @return {Array}
*/
const wrapTags = (text, regex, options = {}) => {
    const {className = 'shortened_url', ignoreLast = false} = options;

    const textArray = text.split(regex);

    return textArray.map((str) => {
        if (regex.test(str)) {
            let string = str;
            let lastSymbol = '';
            let shortenedUrl = shortenUrl(str);

            if (ignoreLast) {
                lastSymbol = string[string.length - 1];
                string = string.slice(0, string.length - 1);
                shortenedUrl = `${shortenedUrl}${lastSymbol}`;
            }

            return (
                <a key={string} rel="noreferrer" onClick={(e) => e.stopPropagation()} href={string} target="_blank" className={className}>
                    {shortenedUrl}
                </a>
            );
        }

        return str;
    });
};

export default wrapTags;
